/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
import React, { useState, useCallback, useEffect, useRef } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { HiDownload } from 'react-icons/hi';
import Input from '../../components/Input';
import { useToast } from '../../hooks/toast';
import Button from '../../components/Button';
import AuthService from '../../services/auth';
import Modal from '../../components/Modal';
import getValidationErrors from '../../utils/getValidationErrors';
import { useAuth } from '../../hooks/auth';
import ModalMotiva from './Components/ModalMotiva';

import { Row, Column } from '../../styles/components';

import {
  Container,
  Title,
  Content,
  WrapperBtn,
  WrapperBtnAlterar,
  WrapperContent,
  ModalWrapper,
} from './styles';
import MainLoader from '../../components/MainLoader';

interface DadosTitular {
  Bairro: string;
  CEP: string;
  CGC: string;
  CPF: any;
  ChaveMunicipio: string | undefined;
  CodigoDoTitular: number;
  Complemento: string;
  DataHoraUltAtualizacao: any;
  EmailTitular: string;
  EmailTitular2: string;
  IdentificadorTitular: number;
  Login: string;
  Modalidade: string;
  NomeFantasia: string;
  NomeLogradouro: string;
  Numero: string;
  QtdeCartoesAtivos: number;
  QtdeFuncAtivos: number;
  RazaoSocial: string;
  Status: number;
  Telefone: string;
  TipoLogradouro: string;
  UF: string;
  NomeMunicipio: string;
}

const schema = Yup.object().shape({
  oldPassword: Yup.string().required('senha antiga obrigatória'),
  newPassword: Yup.string().required('senha nova é obrigatória'),
  confirmPassword: Yup.string()
    .required('confirmação de senha é obrigatória')
    .oneOf([Yup.ref('newPassword'), ''], 'As senhas precisam ser iguais'),
});

const MeuPerfil: React.FC = () => {
  const formSenha = useRef<FormHandles>(null);
  const [titular, setTitular] = useState<DadosTitular>();
  const service = { AuthService: new AuthService() };
  const { addToast } = useToast();
  const [loader, setLoader] = useState<boolean>(false);
  const [acceptLGPD, setAcceptLGPD] = useState<boolean>(false);
  const [modalLGPD, setModalLGPD] = useState<boolean>(false);
  const [modalSenha, setModalSenha] = useState<boolean>(false);
  const [modalMotiva, setModalMotiva] = useState(true);
  const [modalError, setModalError] = useState(false);
  const { signOut } = useAuth();
  const asyncDados = useCallback(async () => {
    try {
      setLoader(true);
      const response = await service.AuthService.getTitular();
      if (
        response?.data?.DadosDoTitular?.Modalidade === 'URA' ||
        response?.data?.DadosDoTitular?.Modalidade === 'PDV'
      ) {
        setModalError(true);
        setModalMotiva(false);
      }
      await setTitular(response.data.DadosDoTitular);
      const codigoMunicipio = response.data.DadosDoTitular.ChaveMunicipio;
      const responseCity = await service.AuthService.getCity(codigoMunicipio);
      await setTitular({
        ...response.data.DadosDoTitular,
        NomeMunicipio: responseCity.data.ListaMunicipios[0].Nome,
      });
      const codigoTitular = response.data.DadosDoTitular.IdentificadorTitular;
      setLoader(false);
      try {
        const responseLGPD = await service.AuthService.acceptedLGPD(
          codigoTitular,
        );
        if (acceptLGPD === false) {
          setModalLGPD(false);
        }
        await setAcceptLGPD(responseLGPD.data.is_accepted);
      } catch (err) {
        console.error(err);
        setModalLGPD(true);
      }
    } catch (err) {
      console.error(err);
      setLoader(false);
    }
  }, []);

  const handleSubmitSenha = useCallback(async (data: any) => {
    try {
      formSenha.current?.setErrors({});
      await schema.validate(data, {
        abortEarly: false,
      });

      setLoader(true);
      await service.AuthService.changePassword(
        data.oldPassword,
        data.newPassword,
        data.confirmPassword,
      );
      setModalSenha(false);
      setLoader(false);
      signOut();
      addToast({
        type: 'success',
        title: 'Sucesso',
        description: 'Senha alterada com sucesso',
      });
    } catch (err: any) {
      const { ...error } = err;
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        formSenha.current?.setErrors(errors);
        return;
      }
      if (typeof error.response.data.detail === 'string') {
        addToast({
          type: 'error',
          title: 'Erro',
          description: error.response.data.detail,
        });
      }
      setModalSenha(false);
      setLoader(false);
    }
  }, []);

  const handleDesloga = () => {
    setModalError(false);
    signOut();
  };

  useEffect(() => {
    asyncDados();
  }, []);

  const handleSubmitLGPD = useCallback(async () => {
    try {
      setLoader(true);
      const response = await service.AuthService.getTitular();
      const codigoTitular = response.data.DadosDoTitular.IdentificadorTitular;
      await service.AuthService.acceptLGPD(codigoTitular);
      setModalLGPD(false);
      setLoader(false);
    } catch (err) {
      setModalLGPD(false);
      console.error(err);
    }
  }, []);

  return (
    <Container>
      {loader && <MainLoader />}
      <Row>
        {/* <Column small="2" medium="2" large="2">
          <InfoContainer className="perfil">
            <InfoItem>
              <span className="info">&#9432;</span>
              <span>Regras de mudança de dados da empresa.</span>
            </InfoItem>
          </InfoContainer>
        </Column> */}
        <Column small="10" medium="10" large="10">
          <Title>{titular?.NomeFantasia}</Title>
          <WrapperBtn>
            <a href="/files/issqn.pdf" download>
              <Button
                color="purple"
                padding="1"
                className="issqn"
                type="button"
                rounded
              >
                <HiDownload />
                &nbsp;Formulário ISSQN
              </Button>
            </a>
            <a href="/files/TermoLGPD_2025.pdf" download>
              <Button color="purple" padding="1" type="button" rounded>
                <HiDownload />
                &nbsp;Termo LGPD
              </Button>
            </a>
          </WrapperBtn>

          {titular && (
            <>
              <Content>
                <Row>
                  <Column small="12" medium="12" large="12">
                    <div className="title">Nome fantasia</div>
                    {titular?.NomeFantasia ? (
                      <>
                        {titular?.NomeFantasia.trim() ? (
                          <div className="text">{titular?.NomeFantasia}</div>
                        ) : (
                          <div className="text">--</div>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="text">--</div>
                      </>
                    )}
                  </Column>
                </Row>
                <Row>
                  <Column small="12" medium="12" large="12">
                    <div className="title">Razão Social</div>
                    {titular?.RazaoSocial ? (
                      <>
                        {titular?.RazaoSocial.trim() ? (
                          <div className="text">{titular?.RazaoSocial}</div>
                        ) : (
                          <div className="text">--</div>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="text">--</div>
                      </>
                    )}
                  </Column>
                </Row>
                <Row>
                  <Column small="6" medium="6" large="6">
                    <div className="title">CNPJ</div>
                    {titular?.CGC ? (
                      <>
                        {titular?.CGC.trim() ? (
                          <div className="text">
                            {titular.CGC.replace(
                              /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                              '$1.$2.$3/$4-$5',
                            )}
                          </div>
                        ) : (
                          <div className="text">--</div>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="text">--</div>
                      </>
                    )}
                  </Column>
                  <Column small="6" medium="6" large="6">
                    <div className="title">EMAIL</div>
                    {titular?.EmailTitular ? (
                      <>
                        {titular?.EmailTitular.trim() ? (
                          <div className="text">{titular?.EmailTitular}</div>
                        ) : (
                          <div className="text">--</div>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="text">--</div>
                      </>
                    )}
                  </Column>
                </Row>
                <Row>
                  {/* <Column small="6" medium="6" large="6">
                    <div className="title">Email alternativo</div>
                    {titular?.EmailTitular2 ? (
                      <>
                        {titular?.EmailTitular2.trim() ? (
                          <div className="text">{titular?.EmailTitular2}</div>
                        ) : (
                          <div className="text">--</div>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="text">--</div>
                      </>
                    )}
                  </Column> */}
                  <Column small="6" medium="6" large="6">
                    <div className="title">Telefone</div>
                    {titular?.Telefone ? (
                      <>
                        {titular?.Telefone.trim() ? (
                          <div className="text">{titular?.Telefone}</div>
                        ) : (
                          <div className="text">--</div>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="text">--</div>
                      </>
                    )}
                  </Column>
                </Row>
                <Row>
                  <Column small="6" medium="6" large="6">
                    <div className="title">Login</div>
                    {titular?.Login ? (
                      <>
                        {titular?.Login.trim() ? (
                          <div className="text login">{titular?.Login}</div>
                        ) : (
                          <div className="text">--</div>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="text">--</div>
                      </>
                    )}
                  </Column>
                  <Column small="5" medium="5" large="5">
                    <WrapperBtnAlterar>
                      <Button
                        color="purple"
                        padding="1"
                        type="button"
                        className="senha"
                        rounded
                        onClick={() => setModalSenha(true)}
                      >
                        Alterar senha
                      </Button>
                    </WrapperBtnAlterar>
                  </Column>
                </Row>
              </Content>
              <WrapperContent>
                <Content>
                  <Row>
                    <Column small="6" medium="6" large="6">
                      <div className="title">Tipo do Logradouro</div>
                      {titular?.TipoLogradouro ? (
                        <>
                          {titular?.TipoLogradouro.trim() ? (
                            <div className="text">
                              {titular?.TipoLogradouro}
                            </div>
                          ) : (
                            <div className="text">--</div>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="text">--</div>
                        </>
                      )}
                    </Column>
                    <Column small="6" medium="6" large="6">
                      <div className="title">Logradouro</div>
                      {titular?.NomeLogradouro ? (
                        <>
                          {titular?.NomeLogradouro.trim() ? (
                            <div className="text">
                              {titular?.NomeLogradouro}
                            </div>
                          ) : (
                            <div className="text">--</div>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="text">--</div>
                        </>
                      )}
                    </Column>
                  </Row>
                  <Row>
                    <Column small="6" medium="6" large="6">
                      <div className="title">Número</div>
                      {titular?.Login ? (
                        <>
                          {titular?.Numero.trim() ? (
                            <div className="text">{titular?.Numero}</div>
                          ) : (
                            <div className="text">--</div>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="text">--</div>
                        </>
                      )}
                    </Column>
                    <Column small="6" medium="6" large="6">
                      <div className="title">Complemento</div>
                      {titular?.Complemento ? (
                        <>
                          {titular?.Complemento.trim() ? (
                            <div className="text">{titular?.Complemento}</div>
                          ) : (
                            <div className="text">--</div>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="text">--</div>
                        </>
                      )}
                    </Column>
                  </Row>
                  <Row>
                    <Column small="6" medium="6" large="6">
                      <div className="title">CEP</div>
                      {titular?.CEP ? (
                        <>
                          {titular?.CEP.trim() ? (
                            <div className="text">
                              {titular.CEP.replace(/^(\d{5})(\d{3})/, '$1-$2')}
                            </div>
                          ) : (
                            <div className="text">--</div>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="text">--</div>
                        </>
                      )}
                    </Column>
                    <Column small="6" medium="6" large="6">
                      <div className="title">Bairro</div>
                      {titular?.Bairro ? (
                        <>
                          {titular?.Bairro.trim() ? (
                            <div className="text">{titular?.Bairro}</div>
                          ) : (
                            <div className="text">--</div>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="text">--</div>
                        </>
                      )}
                    </Column>
                  </Row>
                  <Row>
                    <Column small="6" medium="6" large="6">
                      <div className="title">Estado</div>
                      {titular?.UF ? (
                        <>
                          {titular?.UF.trim() ? (
                            <div className="text">{titular?.UF}</div>
                          ) : (
                            <div className="text">--</div>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="text">--</div>
                        </>
                      )}
                    </Column>

                    <Column small="6" medium="6" large="6">
                      <div className="title">Cidade</div>
                      {titular.NomeMunicipio &&
                        (titular.NomeMunicipio ? (
                          <div className="text">{titular.NomeMunicipio}</div>
                        ) : (
                          <div className="text">---</div>
                        ))}
                    </Column>
                  </Row>
                </Content>
              </WrapperContent>
            </>
          )}
        </Column>
      </Row>
      <Modal
        handleClose={() => setModalSenha(false)}
        show={modalSenha}
        title="Alterar senha"
      >
        <ModalWrapper>
          <Form ref={formSenha} onSubmit={handleSubmitSenha}>
            <Input
              type="password"
              id="oldPassword"
              name="oldPassword"
              label="Senha antiga"
              schema={schema}
            />
            <Input
              type="password"
              id="newPassword"
              name="newPassword"
              label="Nova senha"
              schema={schema}
            />
            <Input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              label="Confirmar nova senha"
              schema={schema}
            />
            <div className="button-wrapper">
              <Button type="submit" color="orange" padding="6">
                Salvar
              </Button>
            </div>
          </Form>
        </ModalWrapper>
      </Modal>
      <Modal
        handleClose={() => setModalLGPD(false)}
        show={modalLGPD}
        title="Atenção!"
      >
        <ModalWrapper>
          <p>
            Nosso termo de adequação da LGPD já está disponível para o
            preenchimento. Clique no botão abaixo para fazer o download,
            {/* &nbsp;
            <a href="/files/TermoLGPD.pdf" download>
              Clique aqui
            </a>
            , */}
            &nbsp;preencha todos os dados necessários e envie no e-mail:&nbsp;
            <a
              href="mailto:contratos@transfacil.com.br"
              target="_blank"
              rel="noreferrer"
            >
              contratos@transfacil.com.br
            </a>
          </p>
          <Button
            type="button"
            color="orange"
            padding="6"
            onClick={handleSubmitLGPD}
          >
            <a href="/files/TermoLGPD_2025.pdf" download>
              Termo LGPD
            </a>
          </Button>
        </ModalWrapper>
      </Modal>
      {modalError && (
        <Modal handleClose={handleDesloga} show={modalError} title="Atenção!">
          <ModalWrapper>
            <h2>Titular não é da modalidade WEB</h2>
            <p>
              Este titular não é um titular da modalidade WEB. Favor entrar em
              contato com o SAC através dos contatos: (31) 3248-7300 ou
              sac@transfacil.com.br.
            </p>
            <Button
              type="button"
              color="orange"
              padding="6"
              onClick={handleDesloga}
            >
              CLIQUE PARA SAIR
            </Button>
          </ModalWrapper>
        </Modal>
      )}
      {modalMotiva && (
        <ModalMotiva
          show={modalMotiva}
          text="Digite o ID numérico do titular e você receberá no email cadastrado instruções."
          handleClose={() => setModalMotiva(false)}
        />
      )}
    </Container>
  );
};

export default MeuPerfil;
